// extracted by mini-css-extract-plugin
export var $animation_name = "ProductsList-module--$animation_name--46551";
export var ProductCard = "ProductsList-module--ProductCard--c6485";
export var ProductsList = "ProductsList-module--ProductsList--1995a";